import React from 'react'
import { useParams } from 'react-router-dom'

import type { UpdateVariantTypesRequestPayload } from '../Product.types'
import { useOfferQuery } from '../hooks/useOfferQuery'
import { ProductVariantsView } from './ProductVariantsView'
import { useUpdateVariantTypesMutation } from './mutations/useUpdateVariantTypesMutation'

export const ProductVariantsContainer = () => {
  const { productId = '' } = useParams<'productId'>()
  const { offerQuery, invalidateOfferQuery } = useOfferQuery([productId])
  const { updateVariantTypesMutation } = useUpdateVariantTypesMutation()

  const updateVariantTypesRequest = (payload: UpdateVariantTypesRequestPayload) => {
    updateVariantTypesMutation.mutate([{ offerId: productId }, payload], {
      onSuccess: invalidateOfferQuery,
    })
  }

  return (
    <ProductVariantsView
      productId={productId}
      productIsFetching={offerQuery.isFetching}
      productVariantTypes={offerQuery.data?.variantTypes || []}
      name={offerQuery.data?.name}
      updateVariantTypesRequest={updateVariantTypesRequest}
    />
  )
}
